<template>
  <v-list dark class="pt-0 nx-bag__container">
    <template v-for="search in searches">
      <nx-bag-list-item :id="search.uuid"
                            :key="search.uuid"
                            :text="search.name"
                            icon="search"
                            @click="$listeners.click(search)">
      </nx-bag-list-item>
    </template>
  </v-list>
</template>

<script>
import NxBagListItem from '../common/BagListItem';

export default {
  components: {
    NxBagListItem,
  },
  props: {
    searches: {
      type: Array,
      required: true,
    },
  },
};
</script>
